import IdyllDocument from "idyll-document";
import * as components from "idyll-components";
import Head from "next/head";
import {useState, useRef} from "react";

import Layout from "./layout.js";
import Root, { Controls } from "../components/Root.js";

import "../styles.scss";

const Footnote = ({ children }) => {
  const [isVisible, setVisible] = useState(false);
  const marginNoteNode = useRef(null);

  return (
    <div className="MarginNoteContainer">
      <span
        className="MarginNoteMarker"
        onClick={() => {
          let dismiss;
          dismiss = event => {
            if (
              (event.target && marginNoteNode && marginNoteNode.current.contains(event.target)) ||
              (typeof TouchEvent !== "undefined" &&
                event instanceof TouchEvent &&
                marginNoteNode.current.contains(event.touches[0].target))
            ) {
              return;
            }

            setVisible(false);
            event.stopPropagation();
            document.removeEventListener("touchstart", dismiss);
            document.removeEventListener("click", dismiss, { capture: true });
          };
          document.addEventListener("touchstart", dismiss);
          document.addEventListener("click", dismiss, {
            capture: true,
          });
          setVisible(true);
        }}
      />
      <div ref={marginNoteNode} className={`MarginNote ${isVisible ? "Visible" : ""}`}>
        {children}
      </div>
    </div>
  );
};

const Hr = () => <hr />

const MailingListInterstitial = () => (<div className="MailingListInterstitialContainer">
<Controls />
</div>
)

const availableComponents = { ...components, Footnote, Hr, MailingListInterstitial };

export default class Post extends React.Component {
  static async getInitialProps({ query }) {
    const markup = await require(`../content/${query.post}.md`);
    return { markup: markup.default };
  }

  render() {
    console.log("Rendering with markup", this.props.markup)
    return (
      <Layout>

      <Head>

      <title>Why books don&rsquo;t work | Andy Matuschak</title>
      <meta
        name="citation_title"
        content="Why books don't work"
      />
      <meta name="citation_author" content="Matuschak Andy" />
      <meta name="citation_publication_date" content="2019" />
      <meta
        name="citation_fulltext_html_url"
        content="https://andymatuschak.org/books"
      />
      <meta name="citation_fulltext_world_readable" content="" />

      <meta property="og:url" content="https://andymatuschak.org/books" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Why books don't work"
      />
      <meta
        property="og:description"
        content="Designing media to reflect how people think and learn"
      />
      <meta
        property="og:image"
        content="https://andymatuschak.org/static/images/social/books.png"
      />
      <meta
        property="og:image:alt"
        content="Title rendered in color: 'Why books don't work'"
      />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1024" />
      <meta property="og:image:height" content="512" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Why books don't work"
      />
      <meta
        name="twitter:image"
        content="https://andymatuschak.org/static/images/social/books.png"
      />
      <meta
        name="twitter:image:alt"
        content="Title rendered in color: 'Why books don't work'"
      />
      <meta
        name="twitter:description"
        content="Designing media to reflect how people think and learn"
      />
      </Head>

        <div className="SidebarContainer">
          <Root sidebar />
          <div className="NotSidebar">
            <div className="wideOnly">
            <Controls />
            </div>
          </div>
        </div>
        <div className="NarrowHeader narrowOnly">
          <div className="NameAndButtons">
            <h1>
              <a href="/">Andy Matuschak</a>
            </h1>
            <div className="HeaderButtons narrowOnly">
              <a href="mailto:andy@andymatuschak.org">Email</a>
              <a href="https://twitter.com/andy_matuschak">Twitter</a>
            </div>
          </div>
        </div>
        <div className="NotSidebar" style={{ flexGrow: 1 }}>
          <div className="PostContainer">
            <article>
              <header>
                <h1>Why books don&rsquo;t work</h1>
              </header>
              <div className="PostBodyContainer">
                <IdyllDocument
                  markup={this.props.markup || ""}
                  components={availableComponents}
                  datasets={{}}
                />
              </div>
            </article>
          </div>
        </div>
      </Layout>
    );
  }
}
